import React from "react";
import { connect } from "react-redux";

const CustomerDetail = (props) => {
  const { order, customer } = props;

  return (
    <div className="card-container customer-detail">
      <div className="card mb-4">
        <div className="card-body customer-detail-body">
          <div className="row">
            <div className="col-4">
              <h3 className="customerDetails-section-header text-content">
                {(customer.first_name ??
                  order.billing_address?.first_name ??
                  "") +
                  " " +
                  (customer.last_name ??
                    order.billing_address?.last_name ??
                    "")}
              </h3>

              <a className="mail-link">
                {customer.email ?? order.billing_address?.email ?? ""}
              </a>
              <p className="text-content">
                {customer.phone ?? order.billing_address?.phone ?? ""}
              </p>
            </div>
            <div className="col-4">
              <h3 className="customerDetails-section-header text-content">
                Billing address
              </h3>

              <p className="text-content">
                {(order.billing_address?.first_name ?? "") +
                  " " +
                  (order.billing_address?.last_name ?? "")}
              </p>
              {order.billing_address?.company && (
                <p className="text-content">{order.billing_address?.company}</p>
              )}
              {order.billing_address?.street_1 && (
                <p className="text-content">
                  {order.billing_address?.street_1}
                </p>
              )}
              {order.billing_address?.street_2 && (
                <p className="text-content">
                  {order.billing_address?.street_2}
                </p>
              )}
              {order.billing_address?.city && (
                <p className="text-content">
                  {order.billing_address?.city +
                    order.billing_address?.state +
                    order.billing_address?.zip}
                </p>
              )}
              {order.billing_address?.country && (
                <p className="text-content">{order.billing_address?.country}</p>
              )}
            </div>
            <div className="col-4">
              <h3 className="customerDetails-section-header text-content">
                Refund rate (last 365 days)
              </h3>

              <p className="text-content">orders</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  order: state.RefundOrder.orderData,
  customer: state.RefundOrder.customerData,
});
export default connect(mapStateToProps)(CustomerDetail);
